import { ClientPurseItem } from 'src/views/widgets/groupedClientPurses/types'

export const findPurse = (
  list: ClientPurseItem[],
  id: number,
): ClientPurseItem | undefined => {
  for (const purse of list) {
    if (purse.clientPurseId === id) {
      return purse
    }

    if (purse.children?.length) {
      const found = findPurse(purse.children, id)
      if (found) {
        return found
      }
    }
  }

  return undefined
}

type PARAMS = {
  list: ClientPurseItem[]
  purseId: number
  groupId: number | null
  ownerClassificationStatus: string
}

export const updatePurseList = ({
  list,
  purseId,
  groupId,
  ownerClassificationStatus,
}: PARAMS): ClientPurseItem[] => {
  return list.map((purse) => {
    if (
      purse.clientPurseId === purseId ||
      (groupId && purse.purseGroupId === groupId)
    ) {
      return purse.children
        ? {
            ...purse,
            ownerClassificationStatus,
            children: updatePurseList({
              list: purse.children,
              purseId,
              groupId,
              ownerClassificationStatus,
            }),
          }
        : { ...purse, ownerClassificationStatus }
    }

    return purse
  })
}
